<template>
  <div>
    <el-table :data="tableData" border>
      <el-table-column prop="ids" :label="$t('app.common.serialNumber')" align="center" width="60px"></el-table-column>
      <el-table-column prop="batchno" :label="$t('app.interSentList.table.batchNo')" align="center"></el-table-column>
      <el-table-column prop="userId" :label="$t('app.interSentList.table.agent')" align="center" v-show="adminShow"></el-table-column>
      <el-table-column prop="msisdn" label="MSISDN" align="center"></el-table-column>
      <el-table-column prop="iccid" label="ICCID" align="center"></el-table-column>
      <el-table-column prop="content" :label="$t('app.interSentList.table.smsContent')" align="center"></el-table-column>
      <el-table-column prop="smsStatus" :label="$t('app.interSentList.table.sendStatus')" align="center" width="100px">
            <template slot-scope="{row}">
                <el-tag v-if="row.smsStatus == '1'" type="success">{{ $t('app.common.success') }}</el-tag>
                <el-tag v-else-if="row.smsStatus == '0'" type="primary">{{ $t('app.common.sending') }}</el-tag>
                <el-tag v-else type="danger">{{ $t('app.common.fail') }}</el-tag>
            </template>
      </el-table-column>
      <el-table-column prop="failReason" :label="$t('app.interSentList.table.failReason')" align="center" min-width="100" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="createTime" :label="$t('app.interSentList.table.sendTime')" align="center"></el-table-column>
    </el-table>
    <div class="block" style="margin-top: 30px;">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
  </div>

</template>
<script>
import { simInterSmsSentList } from "@/api/international.js"; //操作记录
export default {
  data() {
    return{
      tableData:[],
      page: 1,
      pageSize: 10,
      total:0,
    }
  },
  computed: {
    adminShow : {
      get() {
        return this.$store.getters.user.userType =='1'
      }
    },
  },
  created() {
    this.initData();
  },
  methods: {
    // 获操操作列表的数据
    initData(){
      let params = {
        model:{
        },
        page: this.page,
        pageSize: this.pageSize,
      };
        simInterSmsSentList(params).then(res =>{
        if(res.data.code == 200){
          this.tableData = res.data.data.records;
          this.tableData.map((item,index) => {
            item.ids = index + 1;
            item.batchno = item.batchno?item.batchno:"-";
            item.failReason = item.failReason?item.failReason:"-";
          });
          this.total = res.data.data.total;
        }
      })
    },
    // 排序
    compare(property){
      return function(a,b){
        var value1 = a[property];
        var value2 = b[property];
        return value2 - value1;
      }
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.initData();
    },
    handleCurrentChange(page) {
      this.page = page;
      this.initData();
    },
  },

};
</script>

<style scoped lang="less">

</style>


